// extracted by mini-css-extract-plugin
export default {"cakeCard":"FlavorCakeCard_cakeCard__5Htl6"};